import { Pipe, PipeTransform } from '@angular/core';
import { Competition } from '../models/competition';

@Pipe({
  standalone: false,
  name: 'competitionNameSearch',
  pure: false
})
export class CompetitionNameSearchPipe implements PipeTransform {

  transform(competitions: Competition[], filterText: string): Competition[] {

    console.log(filterText);

    if(filterText == undefined || filterText == ""){
      //Return the entire list, unfiltered!
      return competitions;
    }

    let return_list: Competition[] = [];

    let filter_map: Map<string, Competition> = new Map<string, Competition>();

    //Search for match at beginning of name
    competitions.forEach(competition => {

      if(competition.name.indexOf(filterText, 0) > 0){
        return_list.push(competition);
        filter_map.set(competition.id, competition);
      }

    });

    //Now search for match inside of name
    competitions.forEach(competition => {

      if(competition.name.includes(filterText)){
        if(!filter_map.has(competition.id)){
          return_list.push(competition);
        }
      }

    });

    return return_list;

  }

}
